import { CanDeactivateFn } from '@angular/router';
import { ThemesComponent } from '../../features/admin/themes/themes.component';

export const themeEditorCanDeactivateGuard: CanDeactivateFn<ThemesComponent> = (component) => {
  return component.canDeactivate();
};
